<template>

    <div style="width: 100%;height: 400px;background-color: white">
        <HelloWorld v-bind:msg="msg" v-bind:userList = 'userList' name="新的name" />
        <div style="display: flex">
            <div ref="chart"  style="width: 300px;height: 300px;margin-right: 5px">clickMeth</div>
            <div ref="chart1" style="width: 300px;height: 300px;margin-right: 5px">clickMeth</div>
            <div ref="chart2" style="width: 300px;height: 300px;margin-right: 5px">clickMeth</div>
            <div ref="chart3" style="width: 300px;height: 300px;margin-right: 5px">clickMeth</div>
            <div ref="chart4" style="width: 300px;height: 300px;margin-right: 5px">clickMeth</div>
            <div ref="chart5" style="width: 300px;height: 300px;margin-right: 5px" @click="gotoAbout">gotoAbout</div>
        </div>


        <!--<a-button type="primary">阿里云</a-button>-->
        <!--<a-button type="dashed">新浪云</a-button>-->
        <!--<a-button type="danger">腾讯云</a-button>-->


        <el-button type="danger" @click="changeMsgTitle()">点击我该标题=> {{msg}}</el-button>

    </div>
</template>

<script>
    import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
     import * as echarts from 'echarts'

    import {ref} from 'vue'
    export default {
         setup(){
             const userList = [];
             userList.value = [{title:'我是从父组件传过来的值'}];
             const msg = ref('msg');
             const changeMsgTitle=()=>{
                 userList.value = [{title:'aaaaaa'}];
                 msg.value = 'changeMsgTitle'
             };
             return {
                 userList,
                 msg,
                 changeMsgTitle
             }
         },
        components: {
            HelloWorld,
        },
    }
</script>

<style scoped>

</style>
